import { api, apiUrl } from "../../shared/services/service";
import type { AdminAiScanKind, AdminAiScanResponse } from "../models/admin-ai-scans.models";

// Read only a known scan kind; file paths and filesystem discovery stay on the protected backend.
export const getAdminAiScanReports = async (
  scan: AdminAiScanKind,
  signal: AbortSignal,
): Promise<AdminAiScanResponse> => {
  const response = await api.get<AdminAiScanResponse>(`${apiUrl}/admin/ai-scans/${scan}`, { signal });

  return response.data;
};
